export const DC_COLLECTION_TYPES = ['Live', 'Offline'] as const;

export type DcRosterCollectionType = (typeof DC_COLLECTION_TYPES)[number];

export interface DcRosterConfigEventInput {
  code: string;
  collectionType: DcRosterCollectionType | string;
  effort: number | null;
  eventGrade: number | null;
}

export interface DcRosterConfigEvent extends DcRosterConfigEventInput {
  reserved: boolean;
}

export type DcRosterConfigEventUpdate = Pick<
  DcRosterConfigEventInput,
  'collectionType' | 'effort' | 'eventGrade'
>;

export interface DcRosterConfigDocument {
  _id: string;
  dcType: string;
  subType: string;
  description: string;
  collectionEvents: DcRosterConfigEvent[];
}

export type DcRosterConfigCreate = Omit<
  DcRosterConfigDocument,
  '_id' | 'collectionEvents'
> & {
  collectionEvents: DcRosterConfigEventInput[];
};
